import moment from 'moment';
import 'moment-duration-format';

const formatReadTime = (seconds?: number | null) => {
  if (!seconds) return '0m';

  if (seconds < 60) {
    return moment.duration(seconds, 's').format('s[s]');
  }

  if (seconds < 60 * 60) {
    return moment.duration(seconds, 's').format('m[m] s[s]');
  }

  if (seconds < 24 * 60 * 60) {
    return moment.duration(seconds, 's').format('h[h] m[m]');
  }

  return moment.duration(seconds, 's').format('d[d] h[h]');
};

export default formatReadTime;
